// SPDX-FileCopyrightText: 2025 TRUMPF Laser GmbH
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { QCPContextProvider } from '@tls/sw91_ui_templates';
import useIsQC from 'hooks/useIsQC';
import useQCPApi from 'hooks/useQCPApi';
import React, { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

const QCProjectDataProvider = ({ children }: PropsWithChildren) => {
  const isQC = useIsQC();
  const { id } = useParams<{ id?: string }>();
  const { fetchAvailableAlgorithms, fetchQCPProject } = useQCPApi();

  if (isQC) {
    return (
      <QCPContextProvider fetchPluginPackages={fetchAvailableAlgorithms} fetchQCPProject={() => fetchQCPProject(id!)}>
        {children}
      </QCPContextProvider>
    );
  }
  return children;
};
export default QCProjectDataProvider;
